import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { usePolygonContext } from 'src/contexts/polygon.context';
import { actionTypes } from 'src/ducks/polygon.duck';
import { IPolygon } from 'src/models/polygon.model';
import Lang from 'src/libraries/language';
import { getPolygonStatus } from 'src/selectors/polygon.selector';
import style from '../polygon-list/polygon-list.module.scss';

type IProp = {
  data: IPolygon;
};

const PolygonDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = usePolygonContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getPolygonStatus(
    state,
    actionTypes.POLYGON_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.polygonId) {
      const response = await actions.itemDELETE(data.polygonId);

      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(
            Lang.MSG_POLYGON_DELETE_SUCCESS,
            data.polygon
          )
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_POLYGON}
      content={
        <div className={style.content}>
          {Lang.formatString(Lang.MSG_CONFIRM_DELETE, data.polygon)}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default PolygonDelete;
